module.exports = __webpack_public_path__ + "static/media/DestinyandEvanB&W.d5e8b136.png";